















import Vue from "vue";
import ApiService from "@/services/ApiService";
import { apiUrl } from "@/domain";
import dbConnection from "@/services/dbConnection";
import { MLFieldOptions } from "@/constants/ML";

// import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
  name: "SingleMLCsvModal",
  components: {
    // OrgSelectionAdmin,
  },
  data() {
    return {
      form: {
        name: "",
        overwriteCache: false,
      },
      loading: false,
      hasFile: false,
      responseInfo: {
        status: null,
      },
    };
  },
  computed: {
    isSubmitDisabled(): boolean {
      return !this.form.name || !this.hasFile;
    },
  },
  methods: {
    onFileChange(event: Event) {
      const target = event.target as HTMLInputElement;
      this.hasFile = !!target.files?.[0];
    },
    runJourneyGenerationJob() {
      dbConnection.get(apiUrl + "/api/admin/administration/runJourneyGenerationJob").then(() => {

        this.$notify.success({
          title: "Success",
          message: "Journey generation job started",
        });
      });
    },
    submit() {
      const formData = new FormData();
      formData.set("csv_file", this.$refs.file.files[0]);
      formData.set("name", this.form.name);
      formData.set("overwrite_cache", this.form.overwriteCache);
      dbConnection
        .post(apiUrl + "/api/admin/ml/uploadCSV", formData, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then(() => {
          alert("done");
          this.$emit("close");
        });
    },
    close() {
      this.$emit("close");
    },
  },
  // beforeUnmount() {
  //   if (this.timeout) {
  //     clearTimeout(this.timeout);
  //   }
  // },
  mounted() {
    // this.MLFieldOptionsObj = MLFieldOptions.reduce(
    //   (obj, cur) => ({ ...obj, [cur.value]: cur }),
    //   {}
    // );
    // if (this.id != 0) {
    //   ApiService.automationsApi.getSingleAutomation(this.id).then((resp) => {
    //     const obj = resp.data;
    //     // this.form = obj;
    //     this.form.id = this.id;
    //     this.form.name = obj.name;
    //     this.form.tags = obj.tags ? obj.tags.split(",") : [];
    //     this.form.description = obj.description;
    //     this.form.date = obj.date;
    //     this.form.organization_ids = obj.organization_ids
    //       ? obj.organization_ids.split(",")
    //       : [];
    //     // this.form.organization_ids = [];
    //     this.form.query_json = obj.query_json;
    //     this.form.selection_type =
    //       obj.selection_type == "BLACKLIST" ? true : false;
    //     // this.form.custom_rules = JSON.parse(obj.custom_rules);
    //     this.form.extra_options = JSON.parse(obj.extra_options);
    //     this.$forceUpdate();
    //     this.showSchoolFilter = true;
    //   });
    // }
    // this.showSchoolFilter = true;
  },
});
